import React from 'react';
import { CrownFilled, UserOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import { upgradeModal } from 'components/common/CheckPermissions/UpgradeSubscriptionModal';
import Avatar from 'antd/lib/avatar/avatar';
import i18next from 'i18next';
import { EnquiryTypeItem, UserInfo } from 'types/enquiries';
import HeaderUserInfoEnquiryStyles from './styles';

interface Props {
  user: UserInfo;
  enquiryTypeItem?: EnquiryTypeItem;
  isContactSession?: boolean;
  isBlur?: boolean;
  centreId?: string;
}

const HeaderUserInfoEnquiryFallback = ({
  user,
  enquiryTypeItem,
  isContactSession,
  isBlur,
  centreId,
}: Props) => {
  const onClickButton = () => {
    upgradeModal.open(null, centreId);
  };
  return (
    <HeaderUserInfoEnquiryStyles
      className="edit-action-wrapper d-flex"
      role="presentation"
      onClick={onClickButton}
      isContactSession={isContactSession}
    >
      <Avatar size={40} src={user?.avatar} icon={<UserOutlined />} />
      <div className="info-section">
        <div className="title">
          {user?.firstName || ''}
          <span className={isBlur ? 'blur' : ''}>{` ${
            user?.lastName || ''
          }`}</span>
        </div>
        <div className="status">
          {enquiryTypeItem && (
            <Tag color={enquiryTypeItem.color}>
              {i18next.t(enquiryTypeItem.text)}
            </Tag>
          )}
        </div>
      </div>
      <CrownFilled className="action-feature-icon" />
    </HeaderUserInfoEnquiryStyles>
  );
};

export default HeaderUserInfoEnquiryFallback;
